import { defineMessages } from 'react-intl';

export default defineMessages({
  deactivated: {
    id: 'app.containers.RouteList.deactivated',
    defaultMessage: 'Deactivated',
  },
  title: {
    id: 'app.containers.RouteList.title',
    defaultMessage: 'Route Management',
  },
  onSiteLocation: {
    id: 'app.containers.RouteList.onSiteLocation',
    defaultMessage: 'On site location: {meetingPlace}',
  },
});
